import React from 'react';
import './styles/App.css';
import Amplify from 'aws-amplify';
import amplifyConfig from './utils/amplifyConfig';
import { DarkModeProvider } from './context/dark-mode-context';
import { DialogProvider } from './context/dialog-context';
import { AuthProvider } from './context/auth-context';
import { StepProvider } from './context/step-context';
import { NavbarProvider } from './context/navbar-context';
import AppRouter from './pages/AppRouter';
import { useForm, FormProvider } from 'react-hook-form';

Amplify.configure(amplifyConfig);

function App() {
  const methods = useForm();
  return (
    <FormProvider {...methods}>
      <DarkModeProvider>
        <NavbarProvider>
          <AuthProvider>
            <DialogProvider>
              <StepProvider>
                <div className="App">
                  <AppRouter />
                </div>
              </StepProvider>
            </DialogProvider>
          </AuthProvider>
        </NavbarProvider>
      </DarkModeProvider>
    </FormProvider>
  );
}

export default App;
